import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs/internal/ReplaySubject';
import {
  ControlValueAccessor,
  FormGroupDirective,
  NgForm,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

import { GeneralService } from '../../services/general/general.service';
@Component({
  selector: 'app-select-filterable',
  templateUrl: './select-filterable.component.html',
  styleUrls: ['./select-filterable.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectFilterableComponent),
      multi: true,
    },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SelectFilterableComponent implements OnInit, OnDestroy {
  @Input() options = new Array();
  @Input() label = '';
  @Input() type = 1;
  @Input() style = '';
  @Output() onUserChangeValue = new EventEmitter<string>();

  public subscriptions = new Array();
  public filterCtrl = new FormControl();
  public ctrl = new FormControl();
  public filteredOptions: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public notifyParent = true;

  // Dont touch
  onChange = (value: any) => {};
  onTouch = () => {};
  constructor(private general: GeneralService) {
    this.initializeSubscriptions();
  }

  ngOnInit() {
    this.filteredOptions.next(this.options.slice());
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  initializeSubscriptions() {
    this.subscriptions = [
      this.filterCtrl.valueChanges.pipe().subscribe(() => {
        this.toFilterOptions();
      }),

      this.ctrl.valueChanges.pipe().subscribe((data) => {
        if (data && this.notifyParent) {
          this.onChange(data);
        }
      }),
    ];
  }

  toFilterOptions() {
    if (!this.options) {
      return;
    }
    // get the search keyword
    let search = this.filterCtrl.value;
    if (!search) {
      this.filteredOptions.next(this.options.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredOptions.next(
      this.options.filter(
        (opt: any) =>
          opt.label
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .indexOf(search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) >
          -1
      )
    );
  }

  onClick() {
    this.onTouch();
  }

  onUserChangeSelection($event: any) {
    this.onUserChangeValue.emit($event.value);
  }

  /**
   * ====================== ControlValueAccessor Interface functions ======================
   */

  /**
   * Trae el valor puesto en un ngModel, ReactiveForm, etc. Ese valor podemos pasárselo a nuestro input nativo.
   * @param value
   */
  async writeValue(value: any) {
    this.notifyParent = false;
    this.ctrl.patchValue(value);
    await this.general.sleep(200);
    this.notifyParent = true;
  }

  /**
   * Registramos una función que luego usamos para informarle a Angular cuál es el valor de nuestro Form Control.
   * registerOnChange(fn: any): void {}
   * @param fn
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * Registramos una función que luego ejecutaremos cuando necesitemos que nuestro Form Control tenga el estodo “touched”.
   * @param fn
   */
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  /**
   * Trae el estado disabled desde nuestro Reactive Form. Podemos usar este estado para pasarselo a nuesto input nativo.
   * @param isDisabled
   */
  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.ctrl.disable();
    } else {
      this.ctrl.enable();
    }
  }
}
